import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import Context from '@bibliocommons/context';
import { bindAll } from '@bibliocommons/utils-react';
import { libraryShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { SecondaryLink } from '@bibliocommons/base-links';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from 'app/components/shared/FullScreenOverlay';
import Divider from 'app/components/bibs/shared/Divider';

import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';
import { tagShape } from 'app/shapes/bibPage';
import TagList from '../TagList';
import AddTags from '../AddTags';

import './AllCommunityTags.scss';

export default class AllCommunityTags extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderAddTags() {
    const { currentUser } = this.props;
    const { features } = this.context;

    if (currentUser?.get('staff') && features.get(TOGGLZ_FEATURES.ENABLE_BIB_PAGE_STAFF_TAGGING)) {
      return <AddTags metadataId={this.props.metadataId} tagsActions={this.props.tagsActions} />;
    }
    return null;
  }

  render() {
    return (
      <FullScreenOverlayBody className="cp-all-community-tags">
        <FullScreenOverlayHeader title={<FormattedMessage id="all_community_tags" />} />
        <FullScreenOverlayContent size="small">
          <BibBriefContainer metadataId={this.props.metadataId} />
          {this.props.currentLibrary.get('ugcDisclaimerMessageEnabled') && (
            <CommunityDisclaimer type="community_tags" currentLibrary={this.props.currentLibrary} />
          )}
          {this.renderAddTags()}
          <Divider className="divider" />
          <TagList metadataId={this.props.metadataId} tags={this.props.tags} tagType={SecondaryLink} stacked />
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

AllCommunityTags.propTypes = {
  currentLibrary: libraryShape.isRequired,
  currentUser: userIdentityShape,
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.listOf(tagShape).isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func)
};

AllCommunityTags.contextType = Context;
